import { useEffect, useState } from "react";
import api from "@/lib/api";

// Single source of truth: GET /api/program/tiers (backend lifted/tier_config.py).
export function useProgramTiers() {
  const [tiers, setTiers] = useState([]);
  useEffect(() => {
    api.get("/program/tiers").then(({ data }) => setTiers(data.tiers || [])).catch(() => setTiers([]));
  }, []);
  return tiers;
}

export const rankRequirement = (t) =>
  t.rank_purchasable ? "Join for $40/mo (includes Lift-Off membership)" : `Earned at ${t.referrals_required.toLocaleString()} active referrals`;
